export default __webpack_public_path__ + "6b92f631fa32d63bd6876d6ab7195b85.svg";